import { render } from "./AnnotationCard.vue?vue&type=template&id=23680fbc&scoped=true"
import script from "./AnnotationCard.vue?vue&type=script&lang=js"
export * from "./AnnotationCard.vue?vue&type=script&lang=js"

import "./AnnotationCard.vue?vue&type=style&index=0&id=23680fbc&lang=scss"
import "./AnnotationCard.vue?vue&type=style&index=1&id=23680fbc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23680fbc"]])

export default __exports__